import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../models/State"
import {LINK} from "../../config/constants"
import {FacetState} from "../../models/FacetsState"

const selectFacets = (state: State) => state.search.facets
const selectStructuredBrowsingChipsToLoadLimit = (state: State) => state.search.structuredBrowsingChipsToLoadLimit

const makeSelectFacets = createSelector(
    [selectFacets, selectStructuredBrowsingChipsToLoadLimit],
    (facets, structuredBrowsingChipsToLoadLimit) => {
        const categoryFacets: FacetState[] = Object.keys(facets)
            .filter(facetName => facetName.startsWith(LINK))
            .map(facetName => facets[facetName])
            .slice(0, structuredBrowsingChipsToLoadLimit)

        return categoryFacets
    },
)

export const mapStateToProps = (state: State) => {
    const {enableStructuredBrowsing} = state.search
    const {siteUrl} = state.request

    return {
        enableStructuredBrowsing,
        facets: makeSelectFacets(state),
        siteUrl,
        titleText: state.text.pages.structuredBrowsingChips.shopByCategory,
    }
}

export default connect(mapStateToProps)
